import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class NavigationSchnelleinstiegKacheln extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
    }

    connectedCallback() {
        const liste = this.querySelector('.navigation-schnelleinstieg-kacheln');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }

    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get("navigation-schnelleinstieg-kacheln")) {
  customElements.define("navigation-schnelleinstieg-kacheln", NavigationSchnelleinstiegKacheln);
}
